import { useRecord } from "./useRecord";

export function useUserProfile(userId?: string | null) {
  return useRecord("user_profile", userId, { name: "useUserProfile" });
}
